import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const tarifas = [
  {id: null, descripcion: 'No aplica'},
  {id: 1, descripcion: 'Semanal'},
  {id: 2, descripcion: 'Decenal'},
  {id: 5, descripcion: 'Catorcenal'},
  {id: 3, descripcion: 'Quincenal'},
  {id: 4, descripcion: 'Mensual'},
]

export default class NominasNominaCalculoCalcularComponent {
  constructor ($filter, NominasNominaStatusCalculado, NominasNominaCalculoConfiguracion) {
    this.$filter = $filter
    this.NominasNominaStatusCalculado = NominasNominaStatusCalculado
    this.NominasNominaCalculoConfiguracion = NominasNominaCalculoConfiguracion
    this.calculando = false
    this.idEmpresa = null
    this.calculado = false
    this.idNomina = null
    this.configuracion = null
    this.data = null
    this.onChange = null
    this.nominasNomina = null
    this.piramidarEditable = false
    this.opcionCalcularViaticos = false
    this.opcionCalcularAguinaldo = false
    this.opcionTarifa = false
    this.procesando = false
    this.catalogo = {
      tarifas: [],
    }
  }

  $onInit () {
    this.promise = this.NominasNominaCalculoConfiguracion.get(this.idEmpresa, this.idNomina)
      .then((response) => {
        this.configuracion = response.data.configuracion
        this.opcionCalcularViaticos = this.configuracion.id_regimen_fiscal === 9 && this.configuracion.contiene_viaticos
        this.opcionCalcularAguinaldo = this.configuracion.id_regimen_fiscal === 2 && (this.configuracion.fecha.getMonth() + 1) === 12
        this.validar()
      })
  }

  togglePiraminar () {
    this.calculado = false
  }

  toggleAjustarImpuestos () {
    this.calculado = false
  }

  toggleCalcularAguinaldo () {
    this.calculado = false
    this.configuracion.calcular_aguinaldo = this.opcionCalcularAguinaldo && this.configuracion.calcular_aguinaldo
    this.configuracion.piramidar = true
    this.validar()
  }

  toggleCalcularViaticos () {
    this.calculado = false
    this.configuracion.calcular_viaticos = this.opcionCalcularViaticos && this.configuracion.calcular_viaticos
    this.configuracion.piramidar = !this.configuracion.calcular_viaticos
    this.validar()
  }

  validar () {
    this.opcionTarifa = !this.configuracion.calcular_viaticos
    this.piramidarEditable = !this.configuracion.calcular_aguinaldo && !this.configuracion.calcular_viaticos
    this.catalogo.tarifas = tarifas.filter((item) => this.configuracion.calcular_viaticos ? !item.id : item.id)
    this.configuracion.tarifa = this.opcionTarifa ? (this.configuracion.id_tipo_nomina === 0 ? 4 : this.configuracion.id_tipo_nomina) : null
  }

  calcular () {
    this.calculado = false
    this.calculando = true
  }

  guardar () {
    if (this.procesando) return

    this.procesando = true

    let resultados = orderBy(this.data, ['id_empresa', 'id_empleado'])

    let data = {
      configuracion: {
        aplicar_ajuste_impuesto: this.configuracion.aplicar_ajuste_impuesto,
      },
      colaboradores:resultados,
    }


    return this.NominasNominaStatusCalculado.put(this.idEmpresa, this.idNomina, data)
      .then((response) => (this.onChange({$event: {data: response.data}})))
      .finally(() => (this.procesando = false))
  }

  terminar (data) {
    this.calculando = false
    this.calculado = true

    if (data && data.completado) {
      this.data = data.resultado
    }
  }
}

module.component('nominasNominaCalculoCalcular', {
  controller: NominasNominaCalculoCalcularComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
    onChange: '&',
  },
  require: {
    nominasNomina: '^nomina',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/calculo/calcular/component.js